// extracted by css-extract-rspack-plugin
export default {"u-fontisze-1.3":"rR1uO"};